import type { SagaIterator, Task } from 'redux-saga';
import { type ActionPattern, cancel, fork, take } from 'redux-saga/effects';

/*
 * Like `takeLatest` but forks 1 separate saga per form
 * Intended for use with `./take-form.ts`
 */
export const takeFormLatest = function* (
  patternOrChannel: ActionPattern | undefined,
  saga: (...args: any[]) => any,
  ...args: Array<(...args: any[]) => any>
): SagaIterator {
  const formTasks: Record<string, Task> = {};
  while (true) {
    const action = yield take(patternOrChannel);
    const { formName } = action.meta;
    if (formTasks[formName]) {
      yield cancel(formTasks[formName]);
    }

    formTasks[formName] = yield fork(saga, ...args.concat(action));
  }
};
